const REVIEWS = [
  {
    title: "Durable and Stylish!",
    content: "I purchased a coffee table, and it's been a centerpiece in my living room for years. It’s as sturdy as it is beautiful! Highly recommend."
  },
  {
    title: "Amazing Craftsmanship!",
    content: "The quality of the dining set is top-notch. You can tell it’s made with care and precision. It’s the best investment I’ve made for my home."
  },
  {
    title: "Perfect for Any Home!",
    content: "I got a lift table, and it’s been a game-changer. The design is sleek, and the functionality is unmatched. Great value for the price!"
  },
  {
    title: "Exceptional Service!",
    content: "The delivery was quick, and the furniture was packaged securely. I appreciated the attention to detail from start to finish."
  },
  {
    title: "Eco-Friendly and High Quality!",
    content: "Knowing that my furniture is sustainable makes me feel great about my purchase. The quality is excellent, and it fits perfectly in my space."
  },
  {
    title: "Built to Last!",
    content: "I’ve been using my desk for over 5 years, and it still looks brand new. The durability is truly impressive."
  },
  {
    title: "Beautiful and Functional!",
    content: "The storage bench I bought is both practical and elegant. It’s added so much charm to my entryway!"
  },
  {
    title: "Highly Recommend!",
    content: "This is hands down the best furniture store I’ve shopped at. The designs are modern, and the materials feel premium."
  },
  {
    title: "Perfect for Families!",
    content: "Our new dining table has been the heart of family dinners. It’s spacious, sturdy, and easy to clean—perfect for kids!"
  },
  {
    title: "Eco-Friendly Excellence!",
    content: "I love that this brand focuses on sustainability. My bookshelf is not only beautiful but also guilt-free!"
  },
  {
    title: "Exceeded Expectations!",
    content: "I wasn’t sure what to expect, but the quality blew me away. The armchair is so comfortable and looks fantastic in my living room."
  },
  {
    title: "Worth Every Penny!",
    content: "The craftsmanship and design are worth every dollar spent. My wardrobe is solid, spacious, and stunning."
  }
];


export default REVIEWS;

